module.exports = __webpack_public_path__ + "img/ic-merchantqr-step-1.08f8afba.png";